import { createActions, createReducer } from 'reduxsauce';
import { combineReducers } from 'redux';

export const INITIAL_USERS_STATE = {
  fetching: false,
  fetched: false,
  error: null,
  data: [],
};



const { Types, Creators } = createActions(
    {
      getAllUsers: [],
      getAllUsersRequest: [],
      getAllUsersSuccess: ['data'],
      getAllUsersFailure: ['error'],

    },
    { prefix: 'cb/admin/userManager/fetchUsersData' },
);

export { Types as types, Creators as actions };

// Reducers
const request = state => ({
  ...state,
  fetching: true,
  error: null,
  data: null
});

const success = (state, action) => ({
  ...state,
  fetching: false,
  fetched: true,
  data: action.data,
});

const failure = (state, action) => ({
  ...state,
  fetching: false,
  fetched: false,
  error: action.error,
});




export const USERS_HANDLERS = {
  [Types.GET_ALL_USERS_REQUEST]: request,
  [Types.GET_ALL_USERS_SUCCESS]: success,
  [Types.GET_ALL_USERS_FAILURE]: failure,
};


export default createReducer(INITIAL_USERS_STATE, USERS_HANDLERS);